@import (reference) '../../../../../constants/spacing.module.less';

.setting-row {
  grid-column: 1 / span 2;
  display: grid;
}

.setting-checkbox-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
